//LES SERVICES API
let prefix = "/cotation";
export const GET_DATA_TABLE = prefix + "/get-all-articles";

let prefix2 = "/config";
export const GET_CONFIG = prefix2 + "/general/getconfig";
